import background from "../assets/images/background.png";
import "../assets/css/GlobalPlan.css";
export default function GlobalPlan() {
  const idPlan = "arbitragem global";
  return (
    <main
      className="global-plan-container"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="global-plan-eyebrow">Escolha seu plano</div>
      <h1>
        Operação <span>global.</span>
        <br />
        Sem limites de mercado.
      </h1>
      <p className="global-plan-intro">
        Encontre oportunidades em mais de 60 casas globais
        <br className="global-plan-desktop-break" /> e tenha todas as
        ferramentas necessárias para sua operação
        <br className="global-plan-desktop-break" /> em um só lugar.
      </p>

      <section
        className="global-plan-card"
        aria-labelledby="global-plan-plan-title"
      >
        <div className="global-plan-pill">Plano</div>
        <h2 id="global-plan-plan-title">GLOBAL</h2>
        <p className="global-plan-description">
          Tudo o que você precisa para operar
          <br />
          com casas globais.
        </p>
        <ul className="global-plan-features">
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20M4.9 5.5h14.2M4.9 18.5h14.2" />
            </svg>
            <span>
              <strong>Mais de 60</strong> casas globais
            </span>
          </li>
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="2" y="4" width="20" height="18" rx="2" />
              <path d="M16 2v4M8 2v4M2 10h20" />
            </svg>
            <span>Oportunidades pré-evento</span>
          </li>
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="2" width="18" height="20" rx="2" />
              <path d="M7 6h10M7 11h2m3 0h2m3 0h0M7 15h2m3 0h2m3 0h0M7 19h2m3 0h2" />
            </svg>
            <span>Calculadora automática</span>
          </li>
          <li>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="512"
              height="512"
              viewBox="0 0 512 512"
            >
              <path
                fill="none"
                stroke="#ffffff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="M413.66 246.1H386a2 2 0 0 1-2-2v-77.24A38.86 38.86 0 0 0 345.14 128H267.9a2 2 0 0 1-2-2V98.34c0-27.14-21.5-49.86-48.64-50.33a49.53 49.53 0 0 0-50.4 49.51V126a2 2 0 0 1-2 2H87.62A39.74 39.74 0 0 0 48 167.62V238a2 2 0 0 0 2 2h26.91c29.37 0 53.68 25.48 54.09 54.85c.42 29.87-23.51 57.15-53.29 57.15H50a2 2 0 0 0-2 2v70.38A39.74 39.74 0 0 0 87.62 464H158a2 2 0 0 0 2-2v-20.93c0-30.28 24.75-56.35 55-57.06c30.1-.7 57 20.31 57 50.28V462a2 2 0 0 0 2 2h71.14A38.86 38.86 0 0 0 384 425.14v-78a2 2 0 0 1 2-2h28.48c27.63 0 49.52-22.67 49.52-50.4s-23.2-48.64-50.34-48.64"
              />
            </svg>

            <span>Extensão (abre bilhetes)</span>
          </li>
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="2" y="2" width="20" height="20" rx="2" />
              <path d="M2 8h20M8 8v14M2 13h20M12 12h2m3 0h2m-7 4h2m3 0h2m-7 4h2" />
            </svg>
            <span>Planilha Profissional</span>
          </li>
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4 6h16M4 12h16M4 18h16" />
              <circle cx="8" cy="6" r="2" />
              <circle cx="15" cy="12" r="2" />
              <circle cx="10" cy="18" r="2" />
            </svg>
            <span>Filtros personalizáveis</span>
          </li>
          <li>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <path
                fill="none"
                stroke="#ffffff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m4.75 10.75h-3m12.5-2c0 3-2.79822 5.5-6.25 5.5-3.75 0-6.25-3.5-6.25-3.5v3.5m9.5-9h3m-12.5 2c0-3 2.79822-5.5 6.25-5.5 3.75 0 6.25 3.5 6.25 3.5v-3.5"
              />
            </svg>

            <span>Atualizações automáticas</span>
          </li>
        </ul>
        <div className="global-plan-price">
          <strong>R$ 127,00</strong>
          <span>/mês</span>
        </div>
        <a className="global-plan-cta" href={`/payament/${idPlan}`}>
          Quero o plano global{" "}
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 12h14M13 5l7 7-7 7" />
          </svg>
        </a>
      </section>
    </main>
  );
}
